import React from 'react';
import { IconSparkles } from 'src/icons';

interface InsightsCardProps {
  activeTrendValue: number;
  subscriptionCanceled: number;
}

export function InsightsCard({ activeTrendValue, subscriptionCanceled }: InsightsCardProps) {
  return (
    <div className="bg-indigo-50/80 p-1 border border-indigo-100 rounded min-w-0 shrink-0">
      <div className="flex flex-wrap items-center gap-1">
        <span className="flex items-center gap-0.5 font-medium text-[10px] text-gray-900">
          <IconSparkles className="w-3 h-3 text-indigo-600 shrink-0" />
          Insights
        </span>
        <span className="text-[9px] text-gray-600">
          +{activeTrendValue.toFixed(0)}% active · {subscriptionCanceled > 0 ? `${subscriptionCanceled} churn` : 'No churn'}
        </span>
      </div>
    </div>
  );
}
